module.exports = "pegasus/assets/theme6/large/1.jpg";